type CourseDecks = {
  courseId: string;
  decks: string[];
  isInClassroomCourse: boolean;
};

type DeckInfo = {
  courseId: string;
  deckId: string;
  isInClassroomCourse: boolean;
};

const hasDecks = (courseDecks: CourseDecks[]): boolean => {
  return courseDecks.some((course) => course.decks.length > 0);
};

const allDecks = (courseDecks: CourseDecks[]): DeckInfo[] => {
  return courseDecks.flatMap((course) =>
    course.decks.map((deckId) => ({
      courseId: course.courseId,
      deckId,
      isInClassroomCourse: course.isInClassroomCourse,
    }))
  );
};

export { allDecks, hasDecks };
export type { CourseDecks, DeckInfo };
